import {
	Drawer,
	DrawerBody,
	DrawerHeader,
	DrawerHeading,
	FeedbackFreeTextQuestionEvaluation,
	Id,
	createFeedbackQuestionService,
} from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { FeedbackQuestionEvaluationResource } from "../types/feedback";

interface Props {
	eventId: Id;
	open: boolean;
	handleClose: () => void;
	question: FeedbackQuestionEvaluationResource;
}
export const FeedbackFreeTextAnswersDrawer: FC<Props> = ({ eventId, question, open, handleClose }) => {
	const { t } = useTranslation();
	const service = createFeedbackQuestionService(["events", `${eventId}`], "");

	return (
		<Drawer open={open} onClose={handleClose}>
			<DrawerHeader onClose={handleClose}>
				<DrawerHeading>{t("Answers")}</DrawerHeading>
			</DrawerHeader>
			<DrawerBody>
				<FeedbackFreeTextQuestionEvaluation service={service} question={question} />
			</DrawerBody>
		</Drawer>
	);
};
